 /*
创建者 魏强(2018.1.28)
*/
<template>
    <div class="swipe-wrap">
        <div class="swipe" id="leftbrand-swiper2">
            <Carousel
                v-model="value"
                :autoplay="setting.autoplay"
                :autoplay-speed="setting.autoplaySpeed"
                :dots="setting.dots"
                :radius-dot="setting.radiusDot"
                :trigger="setting.trigger"
                :arrow="setting.arrow"
                :height="300"
                :width="300"
            >
                <CarouselItem v-for="item in list" :key="item.key" >
                    <router-link :to="item.to" target="_blank"> 
                        <img :src="item.atturl" height="300px" :alt="item.aname" width="300px" target="_blank" class="scrollLoading">  
                    </router-link>
                </CarouselItem>
            </Carousel>
        </div>
    </div>
</template>
<script>
import {parseAdvList} from "utils/tool.js";
export default{
    props:["data","adDetail"],
    data(){
        return {
            list : parseAdvList(this.data),
            value:0,
            setting: {
                autoplay: true,
                autoplaySpeed: 2000,
                dots: 'inside',
                radiusDot: true,
                trigger: 'hover',
                arrow: 'never'
            } 
        }
    }
}
</script>



// WEBPACK FOOTER //
// ad-list.vue?39975678